<template>
    <div class="academy-container">
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">{{ $t("main-menu22") }}</span>
            </li>
        </ul>
        <div class="wine-guide-head">
            <div class="container">
                <h1 class="inner-page-title">{{ $t('main-menu22') }}</h1>
            </div>
        </div>

        <section id="faq" ref="faq" class="faq-wrapper">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('support-faq-0') }}</h2>
                <div class="title-border"></div>

                <v-text-field class="search-txt" v-model="search" :placeholder="$t('search-faq')"></v-text-field>

                <div class="search-results" v-if="search !== ''">
                    <div class="search-results-info">{{filteredFAQs.total}} search results for <span>{{search}}</span></div>

                    <div class="search-results-table">
                        <h3>{{search}}</h3>
                        <v-expansion-panels>
                            <v-expansion-panel v-if="filteredFAQs['0'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq1') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{ $t('faq2') }}
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['1'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq3') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <i18n path="faq4" tag="p">
                                        <nuxt-link :to="localePath('/trading-desk')" place="market">{{ $t('faq9-2') }}</nuxt-link>
                                    </i18n>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['2'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq5') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>There are two ways to buy wine on the Vindome platform: Collections and Live Market.</p>
                                    <p>Vindome’s Collections make it quick and easy to create a balanced portfolio. Collections are carefully created by our wine investment experts who consider different budgets and investment horizons. Collections are offered at a special rate directly from producers and negociants. Vindome offers a wide choice of wine to suit all tastes. To invest in wines from our Collections, select your preferred Collection, add it to your shopping basket and confirm at checkout. Your Wine Collection will be added to your portfolio and automatically stored in our warehouse.</p>
                                    <p>Should you wish to buy a collection for immediate consumption, please select the request for delivery button prior to checkout. An email will be sent to the Vindome team with your request. We will revert with exact delivery costs and any potential import taxes depending on the country of delivery.</p>
                                    <p>Live Market connects wine investors and collectors globally allowing you to buy and sell wines in real time. Two options exist to buy wine on the Live Market: Price Listed and Place a Bid.</p>
                                    <br/><br/>
                                    <p><strong>How to buy wine at Price Listed</strong></p>
                                    <p>Once you have found a wine you want to buy, follow these simple steps:</p>
                                    <p>1. Select the wine on the Live Market page and click on the 'Buy' button</p>
                                    <p>2. On the right hand side of the screen switch to the 'Buy' tab</p>
                                    <p>3. Add the quantity of cases you wish to purchase</p>
                                    <p>4. Select your preferred payment method </p>
                                    <p>5. Review your order total including commission, storage and insurance fees </p>
                                    <p>6. Click the 'Confirm' button. You will be redirected to the payment page</p>
                                    <p>7. Enter your payment details and click the ‘Pay’ button to complete your investment</p>
                                    <p>Once the payment is successful, we will be confirm your purchase immediately.</p>
                                    <p><i>Please note: Please note: to complete an order, you must have filled out your billing address details for Vindome to include on your invoice. Your wine is automatically stored in our warehouse and will immediately appear in your portfolio.</i></p>
                                    <br/><br/>
                                    <p><strong>How to create a bid</strong></p>
                                    <p>Once you have found a wine you want to bid on, follow these simple steps:</p>
                                    <p>1. Select the wine on the Live Market page and click on the 'Buy' button</p>
                                    <p>2. On the right hand side of the screen switch to the 'Buy' tab</p>
                                    <p>3. Add the quantity of cases you wish to purchase</p>
                                    <p>4. Select your preferred payment method</p>
                                    <p>5. Review your order, this page will contain the Grand total including commission, storage and insurance fees</p>
                                    <p>6. Click 'Confirm' button and you will be redirect to the payment page</p>
                                    <p>7. Enter your payment details and click the ‘Pay’ button to complete your investment</p>
                                    <p>If a seller decides to drop their price and accept your bid, the seller will confirm it. Once the payment has been processed, the wine will show in your portfolio.</p>
                                    <p>If there are several bids for the same wine and price, the seller will match the oldest bid first. A bid can also be partially filled based on quantities available at the bid price.</p>
                                    <p><i>Please note: Vindome will block the funds on your credit card for maximum seven days. This is to ensure that if a bid is matched, the transaction will occur immediately. All your active bids and offers show in your portfolio under Bids & Offers.</i></p>
                                    <p>If you wish to buy a large amount of wine or need help finding what you are looking for, please get in touch with us on <a href="mailto:sales@vindome.net">sales@vindome.net</a>. We will be happy to source any wine you cannot find on <a href="https://vindome.net">Vindome.net</a>.</p>
                                    <p>If you find a wine on the Live Market that you wish to buy, but there's no price indicated, it means the wine exists in one of our user's portfolios and you can Create a Bid. When you place a bid, the owners of the selected wine will be notified and can decide if they want to match your bid.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['3'].show">
                                <v-expansion-panel-header>
                                    How to create a bid for a listed wine without a 'YOU BUY' price?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>If you find a wine on the Live Market that you wish to buy, but there’s no price indicated, it means the wine exists in one of our user’s portfolio and you can Create a Bid. When you place a bid the owners of the selected wine will be notified and can decide to match your bid.</p>
                                    <p><strong>Create a bid</strong></p>
                                    <p>1. Select the wine on the Live Market page and click the 'Buy' button</p>
                                    <p>2. On the right hand side of the screen, make sure you are on the 'Bid' tab</p>
                                    <p>3. Enter the quantity you wish to purchase and a bid price per case</p>
                                    <p><i>Please note that this screen will also show the cost of storage, insurance and commission. Storage and insurance will begin from the day a bid has been matched. Therefore, the final cost might change slightly depending on when the bid is accepted.</i></p>
                                    <p>4. Select your preferred payment method</p>
                                    <p>5. Review your bid and click the 'Confirm' button. You will then be redirected to the payment page.</p>
                                    <p><strong>If a seller decides to sell their wine and accept your bid, your bid will be confirmed. Once the payment has been processed, the wine will show in your portfolio.</strong></p>
                                    <p><i>Please note: Vindome will block the funds on your credit card for maximum seven days. This is to ensure that if a bid is matched the transaction will take place immediately.</i></p>
                                    <p>A list of active bids and offers are listed in section My Portfolio under Bids & Offers.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['4'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faqnew37') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Should you wish to cancel a bid you have placed, go to your Bids & Offers page in your portfolio. Find the offer you want to cancel, select edit, followed by delete. Your bid will be immediately cancelled.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['5'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq10') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Gifting a wine Collection with Vindome is easy. Choose the Collection or Collections you want to give and follow these simple steps:</p>
                                    <p>1. Choose 'Add to basket'</p>
                                    <p>2. Go to the basket, confirm the quantity</p>
                                    <p>3. Tick the box 'I would like to buy as a gift'</p>
                                    <p>4. Confirm that the receiver of the gift is at least 18 years old</p>
                                    <p>5. Enter the name and email address of the gift receiver for a personal gift e-voucher</p>
                                    <p>6. Select your preferred payment method</p>
                                    <p>7. Review your order and click 'Confirm' button, and you will be redirected to the payment page</p>
                                    <p>We will then send a beautifully designed, personalised gift e-voucher to the receiver. You will receive a copy of your invoice as proof of purchase.</p>
                                    <p>The receiver can choose what they want to do with their present: either have it delivered to their door or keep it in our bonded warehouse, gaining value. All storage and insurance fees are included for the first 12 months.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['6'].show">
                                <v-expansion-panel-header>
                                    How do I sell my wine?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Vindome offers two simple ways to sell on the Live Market: create a Sell offer or match an existing Bid.</p>
                                    <p><i>Please note we currently only allow you to sell wines that are listed in your Vindome portfolio, meaning they have been purchased on our platform and are stored in our bonded warehouse.</i></p>
                                    <br/>
                                    <p><strong>Create a Sell offer</strong></p>
                                    <p>1. Go to ‘Portfolio’ and click ‘Investments’, select the wine you wish to sell and click the ‘YOU SELL’ button</p>
                                    <p>2. On the top of the screen stay on the 'Offer' tab</p>
                                    <p>3. Enter the quantity of cases and the price per case you wish to sell for then click "Review order" button</p>
                                    <p>4. On the Review Sell order screen you see the details of your sell offer including the commission charged if the sell offer is matched. It also indicated the potential gain or loss of your investment</p>
                                    <p>5. Review your Sell Offer and click 'Confirm button and your order will appear on the Live Market</p>
                                    <p><i>Please note: In order to place a sell order you will need to add your bank account details in order for Vindome to transfer funds once your wine has been sold.</i></p>
                                    <p>The wine will be removed from your Portfolio once sold. Vindome transfers funds to your bank account within 72 hours. Should you bank account not be credited within this time please get in touch with us on <a href="mailto:info@vindome.net">info@vindome.net</a>.</p>
                                    <p>Your wine will be sold if another user matches the offer you have set. All your active offers are displayed in your Portfolio under Bids & Offers.</p>
                                    <br/>
                                    <p><strong>Matching a Bid</strong></p>
                                    <p>You can also choose to sell your wine by matching a bid on the market. To create the match please:</p>
                                    <p>1. Go to ‘Portfolio’ and click ‘Investments’, select the wine you wish to sell and click the ‘YOU SELL’ button</p>
                                    <p>2. At the top of the screen switch to the 'Sell' tab</p>
                                    <p>3. Enter the quantity of cases you wish to sell at the market price listed</p>
                                    <p>4. Press the ‘Accept Bid’ button and your wine will be sold immediately if it is within 7 days since the buyer placed its bid</p>
                                    <p>If there are no bids on the market the above process will not be possible.</p>
                                    <p>If there are several bids for the same wine and price, the oldest bid will be matched first. A bid can also be partially filled based on quantities available on the market at the bid price.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['7'].show">
                                <v-expansion-panel-header>
                                    How do I cancel a sell offer?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>To cancel a Sell Offer, go to your Bids & Offers page in your portfolio.</p>
                                    <p>Find the offer you want to cancel, select cancel and confirm your choice in the pop-up window.</p>
                                    <p>Your Sell Offer will be immediately cancelled.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['8'].show">
                                <v-expansion-panel-header>
                                    How do I set a price of the wine on the market?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>To change the price or quantity of a current Sell Offer, you need to cancel it and create a new one.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['9'].show">
                                <v-expansion-panel-header>
                                    How do I apply my promo code?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Whether you are on the app or the website, you can use your promo code by accessing your cart. Simply enter your code, then click "Apply".
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['10'].show">
                                <v-expansion-panel-header>
                                    What does Vindome’s investment horizons mean?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Vindome classifies its wine Collections into three investment categories:<br/>
                                    <strong>Short</strong>: suggested investment time is between 2-5 years<br/>
                                    <strong>Medium</strong>: suggested investment time is between 5-10 years<br/>
                                    <strong>Long</strong>: suggested investment time is 10 years plus
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['11'].show">
                                <v-expansion-panel-header>
                                    Where can I see my bids and offers?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    All your active bids and offers are displayed in your Portfolio under Bids & Offers.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['12'].show">
                                <v-expansion-panel-header>
                                    Can I add bottles from my personal wine cellar to my Vindome portfolio?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    No. Vindome does not allow investors to buy or sell wines from their personal collections stored at home or elsewhere. The reason for this is  as we cannot guarantee authenticity and perfect storage conditions. Vindome will only trade wines purchased and stored on our platform. All transactions must be made through Vindome.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['13'].show">
                                <v-expansion-panel-header>
                                    Is there a hold period for my investments?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    No, with Vindome there is no lock-up period. You can sell your wines at any time without penalty fees. Go to our investment tips to learn more about when to sell your wine.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['14'].show">
                                <v-expansion-panel-header>
                                    Can I store my collections in your warehouses?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    We only store wines that have been purchased on our platform. We do not accept private collections for storage as we cannot guarantee authenticity and the conditions in which they have been stored.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['15'].show">
                                <v-expansion-panel-header>
                                    Where can I see information about my orders?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>On the website you can find all information regarding your invoices, transaction history, sales orders and delivery notes in Your Portfolio under the section My Account.</p>
                                    In the App you can find all information regarding your invoices, transaction history, sales orders and delivery notes in the "More" tab in the "My Account" section.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['16'].show">
                                <v-expansion-panel-header>
                                    What is the Portfolio Performance feature?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>The Portfolio Performance feature allows you to track your portfolios performance in real time, visualising:</p>
                                    <ul>
                                        <li>Your current portfolio value compared to the initial investment (value and percentage growth).</li>
                                        <li>Your portfolio charts with the historical market value shown with different data ranges (last month, last six months, last year, since from the beginning).</li>
                                        <li>Number of bottles or cases in your portfolio displayed with different data ranges (last month, last six months, last year, since from the beginning).</li>
                                        <li>Number and value of active bids and offers on the Live Market.</li>
                                        <li>Your portfolio’s composition by wine region and colour.</li>
                                    </ul>
                                    <br/><br/>
                                    All data is certified and updated in real-time by <a href="https://www.winedeciderpro.com/pro3/en/index.php" target="_blank">Wine Decider</a>. Data visualisation can be personalised by editing your Portfolio page.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['17'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq105') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    {{ $t('faq105-1') }}
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['18'].show">
                                <v-expansion-panel-header>
                                    Where can I find my storage and insurance invoices?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    All invoices are displayed in your Invoices under My Account.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['19'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq69') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Seller pays a commission of 4% (four percent) of the selling price
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['20'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq71') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Buyer pays a commission of 4% (four percent) of the buying price
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['21'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq77') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>{{ $t('faqnew143') }}</p>
                                    · {{ $t('faqnew144') }}<br/>
                                    · {{ $t('faqnew145') }}<br/>
                                    · {{ $t('faqnew146') }}<br/>
                                    · {{ $t('faqnew147') }}<br/>
                                    · {{ $t('faqnew148') }}<br/>
                                    <p style="padding-left: 16px;">
                                        ● {{ $t('faqnew149') }}<br/>
                                        ● {{ $t('faqnew150') }}<br/>
                                        ● {{ $t('faqnew151') }}
                                    </p>
                                    <i18n path="faqnew152" tag="p" >
                                        <a href="https://support.triple-a.io/knowledge/what-currencies-can-i-use-to-pay-an-invoice" target="_blank" place="link">{{ $t('faqnew153') }}</a>
                                    </i18n>
                                    <p>{{ $t('faqnew154') }}</p>
                                    <p>{{ $t('faqnew155') }}</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['22'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq79') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    No, Vindome will not retain your credit card details. However, effective from 1st April 2021, we have added a more streamlined payment system allowing our clients to store their credit card details in their accounts. For returning customers, if they have selected this option, they will only be required to insert the registered cards' CVV code.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['23'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faqnew72') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    All the wines for sale on our platform are priced ex VAT. VAT does not apply to wine trades made on the app or website. VAT is charged only on trading commissions, storage and insurance fees, and on the purchase price when the wine is delivered.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['24'].show">
                                <v-expansion-panel-header>
                                    How is the VAT applied?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <strong>Buy</strong>
                                    <p>All the prices that appear on our platform are without VAT.<br/>VAT is charged only when the wines  exit the bonded warehouse for delivery.</p>

                                    <strong>Sell</strong>
                                    <p>No VAT is charged when you sell your wine, so the same case can be bought and resold multiple times with suspended VAT as long as it remains in the bonded warehouse and each transaction is recorded on blockchain to ensure traceability.<br/>Please also note that if you decide to take delivery of a case purchased several years ago and has doubled in value, the VAT is calculated on the purchase price and not on the market value at the time of delivery. Please note any capital gains generated in the event of resale are generally exempt from tax as wine is considered a perishable good. Neverthless, we suggest consulting your local tax advisor.<br/><br/>VAT is charged on storage and insurance fees.</p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['25'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faqnew75') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Vindome can deliver worldwide. Vindome uses only delivery companies specialised in transporting fine wines. Our delivery options ensure high-level product care, secure packaging and careful handling. Please note taxes and delivery charges are added to the wine price and can vary according to the destination. Don't hesitate to get in touch with <a href="mailto:logistics@vindome.net">logistics@vindome.net</a> to get a detailed quote.</p>
                                    <p><i>* Countries where we cannot guarantee deliveries: Yemen, UAE, Pakistan, Sudan, Saudi Arabia, Somalia, Mauritania, Libya, Maldives, Iran, Kuwait, Brunei, Bangladesh and currently Russia.</i></p>
                                    <p><i>** Currently we are also experiencing difficulties with deliveries to the UK.</i></p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['26'].show">
                                <v-expansion-panel-header>
                                    Can my wine be delivered to my home address?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Yes. Vindome is happy to assist you with all arrangements regarding shipments including all customs declaration documents. The total cost of shipment, duty and taxes will be calculated based on the quantity and location of delivery address. Please contact <a href="mailto:info@vindome.net">info@vindome.net</a> to get a detailed quote.</p>
                                    <p><i>Note that Vindome only ships wine by the case. Once you request delivery, the wine cannot be resold on our platform as Vindome cannot guarantee anymore perfect storage conditions and secure premises.</i></p>
                                    <p><i>* Countries where we cannot guarantee deliveries: Yemen, UAE, Pakistan, Sudan, Saudi Arabia, Somalia, Mauritania, Libya, Maldives, Iran, Kuwait, Brunei, Bangladesh and currently Russia.</i></p>
                                    <p><i>** Currently we are also experiencing difficulties with deliveries to the UK.</i></p>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['27'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faqnew78') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Our purpose is to deliver your wine as quickly as possible. However, some of our carrier partners are still working with Covid-19 limitations, and delivery to certain countries may be slightly slower than usual. Please contact us at <a href="mailto:info@vindome.net">info@vindome.net</a>, and we will be happy to give you an estimation of your delivery.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['28'].show">
                                <v-expansion-panel-header>
                                    Where is my wine stored?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    All wines bought on our platform are stored in our partner's bonded, quality-controlled warehouse. Due to their superior reputation and service, we have chosen internationally recognised J.F. Hillebrand as our preferred partner. J. F. Hillebrand bonded warehouses guarantee ideal conditions of constant temperature, humidity and ventilation. Click <a href="https://www.youtube.com/watch?v=jDf6rljhrA0" target="_blank">here</a> to discover how we care for your wine investments. Contact <a href="mailto:info@vindome.net">info@vindome.net</a> if you want to request images of your wine case. If you wish to store your wine in another warehouse, we will deliver it anywhere you want (delivery costs apply).
                                    <br/><br/>
                                    Please note that we only trade wines purchased and stored by Vindome on our platform.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['29'].show">
                                <v-expansion-panel-header>
                                    How much does storage cost?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>We charge a monthly storage fee of Euro 0.99 per case, regardless of the size of the case (1-12 bottles). The storage fee breakdown is as follows:</p>
                                    <p>We charge in advance for the days remaining in the quarter from the date of purchase.<br/>
                                        The storage fee is charged at the end of each quarter.<br/>
                                        Vindome will only charge you the days you keep your wine in storage.<br/>
                                        We will email an invoice to you at the end of each quarter. The invoice will be due for payment within 15 days. Should you fail to pay your storage fees, Vindome has the right to take possession of your wine.<br/>
                                        Storage fee is not applied on En Primeur wines before they are bottled and shipped to our warehouse.<br/>
                                        To pay your storage and insurance fee, please go to Billing under My Account, select the invoice you want to pay and follow the instructions.  On the App you will find your invoices by going to the MORE section, select My Account and then Invoices.</p>

                                    Please get in touch with us at <a href="mailto:logistics@vindome.net">logistics@vindome.net</a> for further details.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['30'].show">
                                <v-expansion-panel-header>
                                    Is my wine insured?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Your wine is fully insured at market value. We report the market value to the warehouse monthly, and your wine's value is adjusted accordingly. For more information regarding our insurance policy, please refer to our T&Cs or contact one of our team members at <a href="mailto:info@vindome.net">info@vindome.net</a>.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['31'].show">
                                <v-expansion-panel-header>
                                    How much does insurance cost?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>The insurance fee is 0.04% per month of the value of the wine stored, with a minimum of Euro 0.10 per case per month. The insurance fee is charged as follows:</p>
                                    <p>We charge in advance for the days remaining in the quarter from the date of purchase.</p>
                                    <p>The insurance fee is charged at the end of each quarter together with the storage fee.</p>
                                    To pay your storage and insurance fee, please go to Billing under My Account, select the invoice you want to pay and follow the instructions. On the App you will find your invoices by going to the MORE section, select My Account and then Invoices. Insurance fee is not applied on En Primeur wines before the commercial release.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['32'].show">
                                <v-expansion-panel-header>
                                    What does the insurance cover?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>The wine stored in our insured partner warehouse J.F. Hillebrand is covered against the following perils:</p>

                                    <p>* Fire, Lightning, explosion</p>
                                    <p>* Attentats (According to the 1986 law)</p>
                                    <p>* Theft and physical inventory differences or discrepancies in the physical counts</p>
                                    <p>* Windstorm, hail, and snow pressure</p>
                                    <p>* Water damage, frost, theft, bottles breakage</p>
                                    <p>* Smoke damage, aircraft impact, vehicle impact</p>
                                    <p>* Malicious damages, riots, civil commotion, terrorism</p>
                                    * Natural disasters (« catastrophes naturelels » as per French law of July 13, 1982 and its endorsements)
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['33'].show">
                                <v-expansion-panel-header>
                                    Is it possible to visit the warehouse?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    You can visit our partner's bonded warehouses by appointment only. For more details, please email us at <a href="mailto:info@vindome.net">info@vindome.net</a>.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['34'].show">
                                <v-expansion-panel-header>
                                    What is Vindome?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Vindome is a fine wine investment platform giving you free access to hundreds of fine wines, En Primeur and hard-to-find releases with guaranteed provenance.</p>
                                    <p>We allow you to buy, bid and sell wine instantly via our easy-to-use mobile app and website. You decide when to sell and make your profit.</p>
                                    Trading wine with other users on our platform is direct, easy and secure. Thanks to our proprietary software, the use of blockchain technology and NFC tags we are able to offer a transparent, efficient wine ecosystem encouraging trade and protecting provenance.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['35'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq3') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <i18n path="faq4" tag="p">
                                        <nuxt-link :to="localePath('/trading-desk')" place="market">{{ $t('faq9-2') }}</nuxt-link>
                                    </i18n>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['36'].show">
                                <v-expansion-panel-header>
                                    Does Vindome have an app for iPhone and Android?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    The Vindome App is available for both Android and iOS. Download the app here.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['37'].show">
                                <v-expansion-panel-header>
                                    Does Vindome offer discounts?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Yes. Our <nuxt-link :to="localePath('/collections')">Collections</nuxt-link> provide superb value for money thanks to our special rates negotiated directly from producers or negociants. Vindome offers a wide choice of wine to suit all tastes.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['38'].show">
                                <v-expansion-panel-header>
                                    Is the Vindome wine market connected to other platforms ?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Vindome is not connected to other wine investment platforms. We do this to preserve the authenticity and provenance of the wines, ideal storage conditions and traceability.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['39'].show">
                                <v-expansion-panel-header>
                                    Why should I invest in wine through Vindome?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>We guarantee the provenance of all wines by only sourcing directly from the producers or negociants.</p>
                                    <p>This short supply chain allows us to offer investable grade fine wines at competitive market rates. All our costs and fees are transparent, and no minimum investment is required to start investing.</p>
                                    With Vindome, you have direct control of your portfolio. Your wines are stored in their original wooden case in our partner bonded warehouses and are fully insured at market value. We provide an integrated trading kit to manage all aspects of your wine investments in one place including: portfolio performance, personalised dashboard, certified market value data from WineDecider.com, wine ratings, drinking windows, wine guide, investment tips, exclusive new release alerts and news.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['40'].show">
                                <v-expansion-panel-header>
                                    How does Vindome source its wine?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    We only work directly with producers or negociants and never use a third-party broker. This means we can guarantee all wines on our platform are 100% authentic. We do not source wine from the secondary market. Every case of wine is sealed with an NFC (Near Field Communication) microchip tag, either directly at the production site or the Vindome warehouse. The tag contains a registration number with information regarding the contents of the case and transaction history, allowing for complete owner anonymity. All trades are recorded on blockchain, guaranteeing traceability for every transaction.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['41'].show">
                                <v-expansion-panel-header>
                                    How does Vindome select its wines?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>We carefully select wines to be featured on our platform by using a team that includes a Master of Wine, sommeliers, wine investment experts and financial analysts. Many factors are taken into consideration, including:</p>
                                    - Producer's brand power and reputation<br/>
                                    - Critic's scores<br/>
                                    - Vintage and climatic conditions<br/>
                                    - Age and rarity<br/>
                                    - Regional trends<br/>
                                    - Classification and appellation<br/>
                                    - Secondary market value<br/>
                                    - Liquidity<br/>
                                    - Special release labels
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['42'].show">
                                <v-expansion-panel-header>
                                    How do I start investing with Vindome?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Investing with Vindome is easy.</p>
                                    Step 1: You can either register on our website by entering your full name and email. Alternatively, download our App and register for free by using your preferred registration option.<br/>
                                    Step 2: Buy wines. Browse our ready-built Wine Collections curated by our experts or find the wine you like on the Live Market, our real-time trading platform. Once you purchased a wine, it will be added directly to your portfolio.<br/>
                                    Step 3: Keep track of your portfolio performance. See your wine’s historical data and follow the latest trade price.<br/>
                                    Step 4: Make a profit by trading as a buyer or seller on our Live Market. Remember to add your bank account details before you start selling.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['43'].show">
                                <v-expansion-panel-header>
                                    {{ $t('faq73') }}
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    All cases for sale on the Vindome platform have been inspected and sealed with an NFC tag. The tag contains a microchip with a detailed information record of the case contents, the transaction history and ensures that your wine is traceable at all times. Furthermore, all wine trades are recorded on blockchain, guaranteeing safe, secure and discreet transactions for both buyer and seller. The tag will be deactivated if you withdraw your wine from the warehouse.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['44'].show">
                                <v-expansion-panel-header>
                                    Do I need expertise to start investing in wine?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    Anyone can start investing in wine with Vindome. We provide you with all detailed trading information about each wine, including region overview, producer's history, wine's description, well-known critics' ratings and wine market performance. Registered users can browse our extensive <nuxt-link :to="localePath('/wine-guide')">wine guides</nuxt-link> and learn more about wine investment thanks to <nuxt-link :to="localePath('/investment-tips')">our tips</nuxt-link>. We will also send push notifications on new investment opportunities and visualise market performances which you access through <nuxt-link :to="localePath('/how-it-works')">our app</nuxt-link>.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['45'].show">
                                <v-expansion-panel-header>
                                    Why is fine wine a good investment?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Fine wine investment has delivered annual returns between 10%-14% over the last 30 years. The market is expected to grow by +54% by 2024, reaching $7.8 billion. Not only is wine profitable, but it’s a relatively safe and stable way to diversify your investment portfolio. It has shown a very low correlation to traditional financial markets during market turbulence. As a tangible asset with a finite supply, wine can protect wealth during economic uncertainty and rising inflation.</p>
                                    Additionally, fine wine has outperformed many established commodities, including gold and real estate, while returns on investment become more consistent and less volatile the longer they are held. Wines should be held for a minimum of five years to optimise returns. Finally, wine is a planet-friendly passion asset with more than 6,000 years of history, making it a sustainable investment.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['46'].show">
                                <v-expansion-panel-header>
                                    What is an investable wine?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Investable wines are wines that increase in monetary value over time and can be traded on a secondary market. While there may be tens of thousands of wine producers across the globe, the best and most exclusive luxury wines make up less than 1% of the world’s total wine production. Different criteria are required for a wine to be considered investable such as:</p>
                                    <ul>
                                        <li>Coming from a specific geological area where the fruit is grown and produced, leading to limited production.</li>
                                        <li>Should have specific and agreed production methods with minimum levels of alcohol and maximum levels off yield. The age of the wine as well as density of plantation.</li>
                                        <li>The wine should have a unique colour, flavour, attractive bouquet, smoothness, and balance with a quality that is improving over time.</li>
                                        <li>Show a healthy return on investment (ROI) over time and having an active secondary market thanks to its brand equity.</li>
                                    </ul>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['47'].show">
                                <v-expansion-panel-header>
                                    What are En Primeur wines and how can I invest in them?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Also known as Wine Futures, En Primeur refers to the process of buying wines in the barrels before they are bottled. Wines are purchased Ex-Vat and Ex-Duty and usually, bottles are physically available 18-24 months after release. The benefits of buying En Primeur are:</p>
                                    <ul>
                                        <li>The opening En Primeur price is considerably cheaper than the future price of the wine on the open market.</li>
                                        <li>When purchasing En Primeur there will be several opportunities even before the wine is bottled to take advantage of price increases and make a profit.</li>
                                        <li>En Primeur can be the only way to secure wines that are available in very limited quantities.</li>
                                    </ul>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['48'].show">
                                <v-expansion-panel-header>
                                    Which wines are best suited for investment?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Fine wine and notably investable fine wine is defined by three points:</p>
                                    <ul>
                                        <li>it comes from a specific, identifiable production area, producers or vineyard which possess a long-standing reputation for high quality. Production volumes are often limited.</li>
                                        <li>it has unique organoleptic properties like colour, flavour, bouquet and taste, universally recognised as such by the world’s most famous wine critics.</li>
                                        <li>it is created to improve as it ages.</li>
                                    </ul>
                                    <br/>
                                    Most of the world's investable wine is produced in Bordeaux, in western France. Burgundy, Champagne and Italy have been key drivers of growth in the last decade and the top wines of these regions are some of the most powerful fine wine brands today. The remainder comes from USA, Rhone Valley and a few notable exceptions from Spain, Germany, Austria, Australia and Latin America.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['49'].show">
                                <v-expansion-panel-header>
                                    Is the Vindome App free?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    The Vindome Mobile App is completely free to download and use.
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel v-if="filteredFAQs['50'].show">
                                <v-expansion-panel-header>
                                    Can I personalise my App Dashboard?
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p>Yes you can customise your dashboard by clicking “Change” in the top right hand corner of the screen. This feature allows you to add and remove custom widgets as well as reorder them to personalize your experience.</p>
                                    Each widget is a wine investment product category. The custom widgets are:<br/><br/>
                                    <ul>
                                        <li>Latest releases</li>
                                        <li>Top movers</li>
                                        <li>Most popular</li>
                                        <li>Favourites</li>
                                    </ul>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>
                </div>

                <v-tabs class="wine-academy-faq-tabs2" vertical v-if="search === ''"  v-model="selectedTab">
                    <v-tab class="most-viewed">
                        {{ $t('support-faq-1') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-2') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('faqnew86') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-3') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-4') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('delivery') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-5') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-6') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-7') }}
                    </v-tab>
                    <v-tab>
                        {{ $t('support-faq-8') }}
                    </v-tab>

                    <v-tab-item class="most-viewed-tab">
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-1') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq5') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faq6') }}</p>
                                            <i18n path="faq8" tag="p">
                                                <nuxt-link :to="localePath('/home/collections')" place="action">{{ $t('faq7') }}</nuxt-link>
                                            </i18n>
                                            <p>{{ $t('faq9') }}</p>
                                            <i18n path="faq9-1" tag="p">
                                                <nuxt-link :to="localePath('/trading-desk')" place="action">{{ $t('faq9-2') }}</nuxt-link>
                                                <nuxt-link :to="localePath('/home/collections')" place="action2">{{ $t('faq9-3') }}</nuxt-link>
                                                <nuxt-link :to="localePath('/home/collections')" place="action3">{{ $t('faq9-4') }}</nuxt-link>
                                            </i18n>
                                            <br/><br/>
                                            <p><strong>{{ $t('faqnew1') }}</strong></p>
                                            <p>{{ $t('faqnew2') }}</p>
                                            <p>{{ $t('faqnew3') }}</p>
                                            <p>{{ $t('faqnew4') }}</p>
                                            <p>{{ $t('faqnew5') }}</p>
                                            <p>{{ $t('faqnew5-1') }}</p>
                                            <p>{{ $t('faqnew6') }}</p>
                                            <p>{{ $t('faqnew7') }}</p>
                                            <p>{{ $t('faqnew8') }}</p>
                                            <p>{{ $t('faqnew9') }}</p>
                                            <p><i>{{ $t('faqnew10') }}</i></p>
                                            <br/><br/>
                                            <p><strong>{{ $t('faqnew11') }}</strong></p>
                                            <p>{{ $t('faqnew12') }}</p>
                                            <p>{{ $t('faqnew13') }}</p>
                                            <p>{{ $t('faqnew14') }}</p>
                                            <p>{{ $t('faqnew15') }}</p>
                                            <p><i>{{ $t('faqnew16') }}</i></p>
                                            <p>{{ $t('faqnew17-1') }}</p>
                                            <p>{{ $t('faqnew17') }}</p>
                                            <p>{{ $t('faqnew19') }}</p>
                                            <p>{{ $t('faqnew20') }}</p>
                                            <p>{{ $t('faqnew21') }}</p>
                                            <i18n path="faqnew22" tag="p">
                                                <a href="mailto:sales@vindome.net" place="salesmail">sales@vindome.net</a>
                                            </i18n>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq58') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew52') }}</p>
                                            <p>{{ $t('faqnew53') }}</p>
                                            <br/>
                                            <p><strong>{{ $t('faqnew54') }}</strong></p>
                                            <p>{{ $t('faqnew55') }}</p>
                                            <p>{{ $t('faqnew56') }}</p>
                                            <p>{{ $t('faqnew57') }}</p>
                                            <p><i>{{ $t('faqnew58') }}</i></p>
                                            <p>{{ $t('faqnew59') }}</p>
                                            <p><i>{{ $t('faqnew60') }}</i></p>
                                            <i18n path="faqnew61" tag="p">
                                                <a href="mailto:info@vindome.net" place="account">info@vindome.net</a>
                                            </i18n>
                                            <br/>
                                            <p><strong>{{ $t('faqnew63') }}</strong></p>
                                            <p>{{ $t('faqnew64') }}</p>
                                            <p>{{ $t('faqnew65') }}</p>
                                            <p>{{ $t('faqnew66') }}</p>
                                            <p>{{ $t('faqnew67') }}</p>
                                            <p>{{ $t('faqnew68') }}</p>
                                            <p>{{ $t('faqnew69') }}</p>
                                            <br/>
                                            <p><strong>{{ $t('faq66') }}</strong></p>
                                            <p>{{ $t('faq67') }}</p>
                                            <p>{{ $t('faq68') }}</p>
                                            <br/>
                                            <p><strong>{{ $t('faq81') }}</strong></p>
                                            <i18n path="faq82" tag="p">
                                                <a href="mailto:info@vindome.net" place="account">info@vindome.net</a>
                                            </i18n>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq69') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            {{ $t('faq70') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq77') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew143') }}</p>
                                            · {{ $t('faqnew144') }}<br/>
                                            · {{ $t('faqnew145') }}<br/>
                                            · {{ $t('faqnew146') }}<br/>
                                            · {{ $t('faqnew147') }}<br/>
                                            · {{ $t('faqnew148') }}<br/>
                                            <p style="padding-left: 16px;">
                                                ● {{ $t('faqnew149') }}<br/>
                                                ● {{ $t('faqnew150') }}<br/>
                                                ● {{ $t('faqnew151') }}
                                            </p>
                                            <i18n path="faqnew152" tag="p" >
                                                <a href="https://support.triple-a.io/knowledge/what-currencies-can-i-use-to-pay-an-invoice" target="_blank" place="link">{{ $t('faqnew153') }}</a>
                                            </i18n>
                                            <p>{{ $t('faqnew154') }}</p>
                                            <p>{{ $t('faqnew155') }}</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq79') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            {{ $t('faq80') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-2') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq1') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            {{ $t('faq2') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq3') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <i18n path="faq4" tag="p">
                                                <nuxt-link :to="localePath('/trading-desk')" place="market">{{ $t('faq9-2') }}</nuxt-link>
                                            </i18n>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew87') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew91') }}</p>
                                            <p>
                                                ● {{ $t('faqnew92') }}<br/>
                                                ● {{ $t('faqnew93') }}<br/>
                                                ● {{ $t('faqnew94') }}<br/>
                                                ● {{ $t('faqnew95') }}
                                            </p>
                                            <p>
                                                {{ $t('faqnew96') }}<br/>
                                                · {{ $t('faqnew97') }}<br/>
                                                · {{ $t('faqnew98') }}<br/>
                                                · {{ $t('faqnew99') }}<br/>
                                                · {{ $t('faqnew100') }}<br/>
                                                · {{ $t('faqnew101') }}<br/>
                                                · {{ $t('faqnew102') }}
                                            </p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew88') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            {{ $t('faqnew103') }}<br/><br/>
                                            ● {{ $t('faqnew104') }}<br/>
                                            ● {{ $t('faqnew105') }}<br/>
                                            ● {{ $t('faqnew106') }}<br/>
                                            ● {{ $t('faqnew107') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew89') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew108') }}</p>
                                            <p>{{ $t('faqnew109') }}</p>
                                            {{ $t('faqnew110') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew90') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew111') }}</p>
                                            <p><strong>{{ $t('faqnew112') }}</strong></p>
                                            {{ $t('faqnew113') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('faqnew86') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq5') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>There are two ways to buy wine on the Vindome platform: Collections and Live Market.</p>
                                            <p>Vindome’s Collections make it quick and easy to create a balanced portfolio. Collections are carefully created by our wine investment experts who consider different budgets and investment horizons. Collections are offered at a special rate directly from producers and negociants. Vindome offers a wide choice of wine to suit all tastes. To invest in wines from our Collections, select your preferred Collection, add it to your shopping basket and confirm at checkout. Your Wine Collection will be added to your portfolio and automatically stored in our warehouse.</p>
                                            <p>Should you wish to buy a collection for immediate consumption, please select the request for delivery button prior to checkout. An email will be sent to the Vindome team with your request. We will revert with exact delivery costs and any potential import taxes depending on the country of delivery.</p>
                                            <p>Live Market connects wine investors and collectors globally allowing you to buy and sell wines in real time. Two options exist to buy wine on the Live Market: Price Listed and Place a Bid.</p>
                                            <br/><br/>
                                            <p><strong>How to buy wine at Price Listed</strong></p>
                                            <p>Once you have found a wine you want to buy, follow these simple steps:</p>
                                            <p>1. Select the wine on the Live Market page and click on the 'Buy' button</p>
                                            <p>2. On the right hand side of the screen switch to the 'Buy' tab</p>
                                            <p>3. Add the quantity of cases you wish to purchase</p>
                                            <p>4. Select your preferred payment method </p>
                                            <p>5. Review your order total including commission, storage and insurance fees </p>
                                            <p>6. Click the 'Confirm' button. You will be redirected to the payment page</p>
                                            <p>7. Enter your payment details and click the ‘Pay’ button to complete your investment</p>
                                            <p>Once the payment is successful, we will be confirm your purchase immediately.</p>
                                            <p><i>Please note: Please note: to complete an order, you must have filled out your billing address details for Vindome to include on your invoice. Your wine is automatically stored in our warehouse and will immediately appear in your portfolio.</i></p>
                                            <br/><br/>
                                            <p><strong>How to create a bid</strong></p>
                                            <p>Once you have found a wine you want to bid on, follow these simple steps:</p>
                                            <p>1. Select the wine on the Live Market page and click on the 'Buy' button</p>
                                            <p>2. On the right hand side of the screen switch to the 'Buy' tab</p>
                                            <p>3. Add the quantity of cases you wish to purchase</p>
                                            <p>4. Select your preferred payment method</p>
                                            <p>5. Review your order, this page will contain the Grand total including commission, storage and insurance fees</p>
                                            <p>6. Click 'Confirm' button and you will be redirect to the payment page</p>
                                            <p>7. Enter your payment details and click the ‘Pay’ button to complete your investment</p>
                                            <p>If a seller decides to drop their price and accept your bid, the seller will confirm it. Once the payment has been processed, the wine will show in your portfolio.</p>
                                            <p>If there are several bids for the same wine and price, the seller will match the oldest bid first. A bid can also be partially filled based on quantities available at the bid price.</p>
                                            <p><i>Please note: Vindome will block the funds on your credit card for maximum seven days. This is to ensure that if a bid is matched, the transaction will occur immediately. All your active bids and offers show in your portfolio under Bids & Offers.</i></p>
                                            <p>If you wish to buy a large amount of wine or need help finding what you are looking for, please get in touch with us on <a href="mailto:sales@vindome.net">sales@vindome.net</a>. We will be happy to source any wine you cannot find on <a href="https://vindome.net">Vindome.net</a>.</p>
                                            <p>If you find a wine on the Live Market that you wish to buy, but there's no price indicated, it means the wine exists in one of our user's portfolios and you can Create a Bid. When you place a bid, the owners of the selected wine will be notified and can decide if they want to match your bid.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How to create a bid for a listed wine without a 'YOU BUY' price?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>If you find a wine on the Live Market that you wish to buy, but there’s no price indicated, it means the wine exists in one of our user’s portfolio and you can Create a Bid. When you place a bid the owners of the selected wine will be notified and can decide to match your bid.</p>
                                            <p><strong>Create a bid</strong></p>
                                            <p>1. Select the wine on the Live Market page and click the 'Buy' button</p>
                                            <p>2. On the right hand side of the screen, make sure you are on the 'Bid' tab</p>
                                            <p>3. Enter the quantity you wish to purchase and a bid price per case</p>
                                            <p><i>Please note that this screen will also show the cost of storage, insurance and commission. Storage and insurance will begin from the day a bid has been matched. Therefore, the final cost might change slightly depending on when the bid is accepted.</i></p>
                                            <p>4. Select your preferred payment method</p>
                                            <p>5. Review your bid and click the 'Confirm' button. You will then be redirected to the payment page.</p>
                                            <p><strong>If a seller decides to sell their wine and accept your bid, your bid will be confirmed. Once the payment has been processed, the wine will show in your portfolio.</strong></p>
                                            <p><i>Please note: Vindome will block the funds on your credit card for maximum seven days. This is to ensure that if a bid is matched the transaction will take place immediately.</i></p>
                                            <p>A list of active bids and offers are listed in section My Portfolio under Bids & Offers.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew37') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Should you wish to cancel a bid you have placed, go to your Bids & Offers page in your portfolio. Find the offer you want to cancel, select edit, followed by delete. Your bid will be immediately cancelled.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq10') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Gifting a wine Collection with Vindome is easy. Choose the Collection or Collections you want to give and follow these simple steps:</p>
                                            <p>1. Choose 'Add to basket'</p>
                                            <p>2. Go to the basket, confirm the quantity</p>
                                            <p>3. Tick the box 'I would like to buy as a gift'</p>
                                            <p>4. Confirm that the receiver of the gift is at least 18 years old</p>
                                            <p>5. Enter the name and email address of the gift receiver for a personal gift e-voucher</p>
                                            <p>6. Select your preferred payment method</p>
                                            <p>7. Review your order and click 'Confirm' button, and you will be redirected to the payment page</p>
                                            <p>We will then send a beautifully designed, personalised gift e-voucher to the receiver. You will receive a copy of your invoice as proof of purchase.</p>
                                            <p>The receiver can choose what they want to do with their present: either have it delivered to their door or keep it in our bonded warehouse, gaining value. All storage and insurance fees are included for the first 12 months.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How do I sell my wine?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Vindome offers two simple ways to sell on the Live Market: create a Sell offer or match an existing Bid.</p>
                                            <p><i>Please note we currently only allow you to sell wines that are listed in your Vindome portfolio, meaning they have been purchased on our platform and are stored in our bonded warehouse.</i></p>
                                            <br/>
                                            <p><strong>Create a Sell offer</strong></p>
                                            <p>1. Go to ‘Portfolio’ and click ‘Investments’, select the wine you wish to sell and click the ‘YOU SELL’ button</p>
                                            <p>2. On the top of the screen stay on the 'Offer' tab</p>
                                            <p>3. Enter the quantity of cases and the price per case you wish to sell for then click "Review order" button</p>
                                            <p>4. On the Review Sell order screen you see the details of your sell offer including the commission charged if the sell offer is matched. It also indicated the potential gain or loss of your investment</p>
                                            <p>5. Review your Sell Offer and click 'Confirm button and your order will appear on the Live Market</p>
                                            <p><i>Please note: In order to place a sell order you will need to add your bank account details in order for Vindome to transfer funds once your wine has been sold.</i></p>
                                            <p>The wine will be removed from your Portfolio once sold. Vindome transfers funds to your bank account within 72 hours. Should you bank account not be credited within this time please get in touch with us on <a href="mailto:info@vindome.net">info@vindome.net</a>.</p>
                                            <p>Your wine will be sold if another user matches the offer you have set. All your active offers are displayed in your Portfolio under Bids & Offers.</p>
                                            <br/>
                                            <p><strong>Matching a Bid</strong></p>
                                            <p>You can also choose to sell your wine by matching a bid on the market. To create the match please:</p>
                                            <p>1. Go to ‘Portfolio’ and click ‘Investments’, select the wine you wish to sell and click the ‘YOU SELL’ button</p>
                                            <p>2. At the top of the screen switch to the 'Sell' tab</p>
                                            <p>3. Enter the quantity of cases you wish to sell at the market price listed</p>
                                            <p>4. Press the ‘Accept Bid’ button and your wine will be sold immediately if it is within 7 days since the buyer placed its bid</p>
                                            <p>If there are no bids on the market the above process will not be possible.</p>
                                            <p>If there are several bids for the same wine and price, the oldest bid will be matched first. A bid can also be partially filled based on quantities available on the market at the bid price.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How do I cancel a sell offer?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>To cancel a Sell Offer, go to your Bids & Offers page in your portfolio.</p>
                                            <p>Find the offer you want to cancel, select cancel and confirm your choice in the pop-up window.</p>
                                            <p>Your Sell Offer will be immediately cancelled.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How do I set a price of the wine on the market?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>To change the price or quantity of a current Sell Offer, you need to cancel it and create a new one.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How do I apply my promo code?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Whether you are on the app or the website, you can use your promo code by accessing your cart. Simply enter your code, then click "Apply".
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What does Vindome’s investment horizons mean?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Vindome classifies its wine Collections into three investment categories:<br/>
                                            <strong>Short</strong>: suggested investment time is between 2-5 years<br/>
                                            <strong>Medium</strong>: suggested investment time is between 5-10 years<br/>
                                            <strong>Long</strong>: suggested investment time is 10 years plus
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>


                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew114') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew116') }}</p>
                                            <p>{{ $t('faqnew117') }}<br/>
                                            · {{ $t('faqnew118') }}<br/>
                                            · {{ $t('faqnew119') }}<br/>
                                            · {{ $t('faqnew120') }}
                                            </p>
                                            {{ $t('faqnew121') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew115') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew122') }}</p>
                                            <p>{{ $t('faqnew123') }}</p>
                                            <p>{{ $t('faqnew124') }}<br/>
                                            1. {{ $t('faqnew125') }}<br/>
                                            2. {{ $t('faqnew126') }}<br/>
                                            3. {{ $t('faqnew127') }}<br/>
                                            4. {{ $t('faqnew128') }}</p>
                                            <p>{{ $t('faqnew129') }}</p>
                                            <p>{{ $t('faqnew130') }}</p>
                                            <p><strong>{{ $t('faqnew131') }}</strong></p>
                                            <p>{{ $t('faqnew132') }}<br/>
                                            · {{ $t('faqnew133') }}<br/>
                                            · {{ $t('faqnew134') }}<br/>
                                            · {{ $t('faqnew135') }}</p>
                                            <p><strong>{{ $t('faqnew136') }}</strong><br/>
                                            {{ $t('faqnew137') }}<br/>
                                            </p>
                                            <p><strong>{{ $t('faqnew139') }}</strong><br/>
                                                {{ $t('faqnew140') }}
                                            </p>
                                            <strong>{{ $t('faqnew141') }}</strong><br/>
                                            {{ $t('faqnew142') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-3') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Where can I see my bids and offers?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            All your active bids and offers are displayed in your Portfolio under Bids & Offers.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Can I add bottles from my personal wine cellar to my Vindome portfolio?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            No. Vindome does not allow investors to buy or sell wines from their personal collections stored at home or elsewhere. The reason for this is  as we cannot guarantee authenticity and perfect storage conditions. Vindome will only trade wines purchased and stored on our platform. All transactions must be made through Vindome.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Is there a hold period for my investments?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            No, with Vindome there is no lock-up period. You can sell your wines at any time without penalty fees. Go to our investment tips to learn more about when to sell your wine.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Can I store my collections in your warehouses?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            We only store wines that have been purchased on our platform. We do not accept private collections for storage as we cannot guarantee authenticity and the conditions in which they have been stored.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Where can I see information about my orders?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>On the website you can find all information regarding your invoices, transaction history, sales orders and delivery notes in Your Portfolio under the section My Account.</p>
                                            In the App you can find all information regarding your invoices, transaction history, sales orders and delivery notes in the "More" tab in the "My Account" section.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What is the Portfolio Performance feature?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>The Portfolio Performance feature allows you to track your portfolios performance in real time, visualising:</p>
                                            <p>
                                                <ul>
                                                    <li>Your current portfolio value compared to the initial investment (value and percentage growth).</li>
                                                    <li>Your portfolio charts with the historical market value shown with different data ranges (last month, last six months, last year, since from the beginning).</li>
                                                    <li>Number of bottles or cases in your portfolio displayed with different data ranges (last month, last six months, last year, since from the beginning).</li>
                                                    <li>Number and value of active bids and offers on the Live Market.</li>
                                                    <li>Your portfolio’s composition by wine region and colour.</li>
                                                </ul>
                                            </p>

                                            All data is certified and updated in real-time by <a href="https://www.winedeciderpro.com/pro3/en/index.php" target="_blank">Wine Decider</a>. Data visualisation can be personalised by editing your Portfolio page.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq105') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            {{ $t('faq105-1') }}
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-4') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Where can I find my storage and insurance invoices?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            All invoices are displayed in your Invoices under My Account.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq69') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Seller pays a commission of 4% (four percent) of the selling price
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq71') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Buyer pays a commission of 4% (four percent) of the buying price
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq77') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>{{ $t('faqnew143') }}</p>
                                            · {{ $t('faqnew144') }}<br/>
                                            · {{ $t('faqnew145') }}<br/>
                                            · {{ $t('faqnew146') }}<br/>
                                            · {{ $t('faqnew147') }}<br/>
                                            · {{ $t('faqnew148') }}<br/>
                                            <p style="padding-left: 16px;">
                                                ● {{ $t('faqnew149') }}<br/>
                                                ● {{ $t('faqnew150') }}<br/>
                                                ● {{ $t('faqnew151') }}
                                            </p>
                                            <i18n path="faqnew152" tag="p" >
                                                <a href="https://support.triple-a.io/knowledge/what-currencies-can-i-use-to-pay-an-invoice" target="_blank" place="link">{{ $t('faqnew153') }}</a>
                                            </i18n>
                                            <p>{{ $t('faqnew154') }}</p>
                                            <p>{{ $t('faqnew155') }}</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq79') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            No, Vindome will not retain your credit card details. However, effective from 1st April 2021, we have added a more streamlined payment system allowing our clients to store their credit card details in their accounts. For returning customers, if they have selected this option, they will only be required to insert the registered cards' CVV code.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew72') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            All the wines for sale on our platform are priced ex VAT. VAT does not apply to wine trades made on the app or website. VAT is charged only on trading commissions, storage and insurance fees, and on the purchase price when the wine is delivered.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How is the VAT applied?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <strong>Buy</strong>
                                            <p>All the prices that appear on our platform are without VAT.<br/>VAT is charged only when the wines  exit the bonded warehouse for delivery.</p>

                                            <strong>Sell</strong>
                                            <p>No VAT is charged when you sell your wine, so the same case can be bought and resold multiple times with suspended VAT as long as it remains in the bonded warehouse and each transaction is recorded on blockchain to ensure traceability.<br/>Please also note that if you decide to take delivery of a case purchased several years ago and has doubled in value, the VAT is calculated on the purchase price and not on the market value at the time of delivery. Please note any capital gains generated in the event of resale are generally exempt from tax as wine is considered a perishable good. Neverthless, we suggest consulting your local tax advisor.<br/><br/>VAT is charged on storage and insurance fees.</p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('delivery') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew75') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Vindome can deliver worldwide. Vindome uses only delivery companies specialised in transporting fine wines. Our delivery options ensure high-level product care, secure packaging and careful handling. Please note taxes and delivery charges are added to the wine price and can vary according to the destination. Don't hesitate to get in touch with <a href="mailto:logistics@vindome.net">logistics@vindome.net</a> to get a detailed quote.</p>
                                            <p><i>* Countries where we cannot guarantee deliveries: Yemen, UAE, Pakistan, Sudan, Saudi Arabia, Somalia, Mauritania, Libya, Maldives, Iran, Kuwait, Brunei, Bangladesh and currently Russia.</i></p>
                                            <p><i>** Currently we are also experiencing difficulties with deliveries to the UK.</i></p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Can my wine be delivered to my home address?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Yes. Vindome is happy to assist you with all arrangements regarding shipments including all customs declaration documents. The total cost of shipment, duty and taxes will be calculated based on the quantity and location of delivery address. Please contact <a href="mailto:info@vindome.net">info@vindome.net</a> to get a detailed quote.</p>
                                            <p><i>Note that Vindome only ships wine by the case. Once you request delivery, the wine cannot be resold on our platform as Vindome cannot guarantee anymore perfect storage conditions and secure premises.</i></p>
                                            <p><i>* Countries where we cannot guarantee deliveries: Yemen, UAE, Pakistan, Sudan, Saudi Arabia, Somalia, Mauritania, Libya, Maldives, Iran, Kuwait, Brunei, Bangladesh and currently Russia.</i></p>
                                            <p><i>** Currently we are also experiencing difficulties with deliveries to the UK.</i></p>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faqnew78') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Our purpose is to deliver your wine as quickly as possible. However, some of our carrier partners are still working with Covid-19 limitations, and delivery to certain countries may be slightly slower than usual. Please contact us at <a href="mailto:info@vindome.net">info@vindome.net</a>, and we will be happy to give you an estimation of your delivery.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-5') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Where is my wine stored?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            All wines bought on our platform are stored in our partner's bonded, quality-controlled warehouse. Due to their superior reputation and service, we have chosen internationally recognised J.F. Hillebrand as our preferred partner. J. F. Hillebrand bonded warehouses guarantee ideal conditions of constant temperature, humidity and ventilation. Click <a href="https://www.youtube.com/watch?v=jDf6rljhrA0" target="_blank">here</a> to discover how we care for your wine investments. Contact <a href="mailto:info@vindome.net">info@vindome.net</a> if you want to request images of your wine case. If you wish to store your wine in another warehouse, we will deliver it anywhere you want (delivery costs apply).
                                            <br/><br/>
                                            Please note that we only trade wines purchased and stored by Vindome on our platform.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How much does storage cost?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>We charge a monthly storage fee of Euro 0.99 per case, regardless of the size of the case (1-12 bottles). The storage fee breakdown is as follows:</p>
                                            <p>We charge in advance for the days remaining in the quarter from the date of purchase.<br/>
                                                The storage fee is charged at the end of each quarter.<br/>
                                                Vindome will only charge you the days you keep your wine in storage.<br/>
                                                We will email an invoice to you at the end of each quarter. The invoice will be due for payment within 15 days. Should you fail to pay your storage fees, Vindome has the right to take possession of your wine.<br/>
                                                Storage fee is not applied on En Primeur wines before they are bottled and shipped to our warehouse.<br/>
                                                To pay your storage and insurance fee, please go to Billing under My Account, select the invoice you want to pay and follow the instructions.  On the App you will find your invoices by going to the MORE section, select My Account and then Invoices.</p>

                                            Please get in touch with us at <a href="mailto:logistics@vindome.net">logistics@vindome.net</a> for further details.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Is my wine insured?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Your wine is fully insured at market value. We report the market value to the warehouse monthly, and your wine's value is adjusted accordingly. For more information regarding our insurance policy, please refer to our T&Cs or contact one of our team members at <a href="mailto:info@vindome.net">info@vindome.net</a>.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How much does insurance cost?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>The insurance fee is 0.04% per month of the value of the wine stored, with a minimum of Euro 0.10 per case per month. The insurance fee is charged as follows:</p>
                                            <p>We charge in advance for the days remaining in the quarter from the date of purchase.</p>
                                            <p>The insurance fee is charged at the end of each quarter together with the storage fee.</p>
                                            To pay your storage and insurance fee, please go to Billing under My Account, select the invoice you want to pay and follow the instructions. On the App you will find your invoices by going to the MORE section, select My Account and then Invoices. Insurance fee is not applied on En Primeur wines before the commercial release.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What does the insurance cover?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>The wine stored in our insured partner warehouse J.F. Hillebrand is covered against the following perils:</p>

                                            <p>* Fire, Lightning, explosion</p>
                                            <p>* Attentats (According to the 1986 law)</p>
                                            <p>* Theft and physical inventory differences or discrepancies in the physical counts</p>
                                            <p>* Windstorm, hail, and snow pressure</p>
                                            <p>* Water damage, frost, theft, bottles breakage</p>
                                            <p>* Smoke damage, aircraft impact, vehicle impact</p>
                                            <p>* Malicious damages, riots, civil commotion, terrorism</p>
                                            * Natural disasters (« catastrophes naturelels » as per French law of July 13, 1982 and its endorsements)
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Is it possible to visit the warehouse?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            You can visit our partner's bonded warehouses by appointment only. For more details, please email us at <a href="mailto:info@vindome.net">info@vindome.net</a>.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-6') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What is Vindome?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Vindome is a fine wine investment platform giving you free access to hundreds of fine wines, En Primeur and hard-to-find releases with guaranteed provenance.</p>
                                            <p>We allow you to buy, bid and sell wine instantly via our easy-to-use mobile app and website. You decide when to sell and make your profit.</p>
                                            Trading wine with other users on our platform is direct, easy and secure. Thanks to our proprietary software, the use of blockchain technology and NFC tags we are able to offer a transparent, efficient wine ecosystem encouraging trade and protecting provenance.
                                         </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq3') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <i18n path="faq4" tag="p">
                                                <nuxt-link :to="localePath('/trading-desk')" place="market">{{ $t('faq9-2') }}</nuxt-link>
                                            </i18n>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Does Vindome have an app for iPhone and Android?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            The Vindome App is available for both Android and iOS. Download the app here.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Does Vindome offer discounts?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Yes. Our <nuxt-link :to="localePath('/collections')">Collections</nuxt-link> provide superb value for money thanks to our special rates negotiated directly from producers or negociants. Vindome offers a wide choice of wine to suit all tastes.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Is the Vindome wine market connected to other platforms ?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Vindome is not connected to other wine investment platforms. We do this to preserve the authenticity and provenance of the wines, ideal storage conditions and traceability.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Why should I invest in wine through Vindome?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>We guarantee the provenance of all wines by only sourcing directly from the producers or negociants.</p>
                                            <p>This short supply chain allows us to offer investable grade fine wines at competitive market rates. All our costs and fees are transparent, and no minimum investment is required to start investing.</p>
                                            With Vindome, you have direct control of your portfolio. Your wines are stored in their original wooden case in our partner bonded warehouses and are fully insured at market value. We provide an integrated trading kit to manage all aspects of your wine investments in one place including: portfolio performance, personalised dashboard, certified market value data from WineDecider.com, wine ratings, drinking windows, wine guide, investment tips, exclusive new release alerts and news.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How does Vindome source its wine?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            We only work directly with producers or negociants and never use a third-party broker. This means we can guarantee all wines on our platform are 100% authentic. We do not source wine from the secondary market. Every case of wine is sealed with an NFC (Near Field Communication) microchip tag, either directly at the production site or the Vindome warehouse. The tag contains a registration number with information regarding the contents of the case and transaction history, allowing for complete owner anonymity. All trades are recorded on blockchain, guaranteeing traceability for every transaction.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How does Vindome select its wines?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>We carefully select wines to be featured on our platform by using a team that includes a Master of Wine, sommeliers, wine investment experts and financial analysts. Many factors are taken into consideration, including:</p>
                                            - Producer's brand power and reputation<br/>
                                            - Critic's scores<br/>
                                            - Vintage and climatic conditions<br/>
                                            - Age and rarity<br/>
                                            - Regional trends<br/>
                                            - Classification and appellation<br/>
                                            - Secondary market value<br/>
                                            - Liquidity<br/>
                                            - Special release labels
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            How do I start investing with Vindome?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Investing with Vindome is easy.</p>
                                            Step 1: You can either register on our website by entering your full name and email. Alternatively, download our App and register for free by using your preferred registration option.<br/>
                                            Step 2: Buy wines. Browse our ready-built Wine Collections curated by our experts or find the wine you like on the Live Market, our real-time trading platform. Once you purchased a wine, it will be added directly to your portfolio.<br/>
                                            Step 3: Keep track of your portfolio performance. See your wine’s historical data and follow the latest trade price.<br/>
                                            Step 4: Make a profit by trading as a buyer or seller on our Live Market. Remember to add your bank account details before you start selling.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            {{ $t('faq73') }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            All cases for sale on the Vindome platform have been inspected and sealed with an NFC tag. The tag contains a microchip with a detailed information record of the case contents, the transaction history and ensures that your wine is traceable at all times. Furthermore, all wine trades are recorded on blockchain, guaranteeing safe, secure and discreet transactions for both buyer and seller. The tag will be deactivated if you withdraw your wine from the warehouse.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-7') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Do I need expertise to start investing in wine?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            Anyone can start investing in wine with Vindome. We provide you with all detailed trading information about each wine, including region overview, producer's history, wine's description, well-known critics' ratings and wine market performance. Registered users can browse our extensive <nuxt-link :to="localePath('/wine-guide')">wine guides</nuxt-link> and learn more about wine investment thanks to <nuxt-link :to="localePath('/investment-tips')">our tips</nuxt-link>. We will also send push notifications on new investment opportunities and visualise market performances which you access through <nuxt-link :to="localePath('/how-it-works')">our app</nuxt-link>.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Why is fine wine a good investment?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Fine wine investment has delivered annual returns between 10%-14% over the last 30 years. The market is expected to grow by +54% by 2024, reaching $7.8 billion. Not only is wine profitable, but it’s a relatively safe and stable way to diversify your investment portfolio. It has shown a very low correlation to traditional financial markets during market turbulence. As a tangible asset with a finite supply, wine can protect wealth during economic uncertainty and rising inflation.</p>
                                            Additionally, fine wine has outperformed many established commodities, including gold and real estate, while returns on investment become more consistent and less volatile the longer they are held. Wines should be held for a minimum of five years to optimise returns. Finally, wine is a planet-friendly passion asset with more than 6,000 years of history, making it a sustainable investment.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What is an investable wine?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Investable wines are wines that increase in monetary value over time and can be traded on a secondary market. While there may be tens of thousands of wine producers across the globe, the best and most exclusive luxury wines make up less than 1% of the world’s total wine production. Different criteria are required for a wine to be considered investable such as:</p>
                                            <ul>
                                                <li>Coming from a specific geological area where the fruit is grown and produced, leading to limited production.</li>
                                                <li>Should have specific and agreed production methods with minimum levels of alcohol and maximum levels off yield. The age of the wine as well as density of plantation.</li>
                                                <li>The wine should have a unique colour, flavour, attractive bouquet, smoothness, and balance with a quality that is improving over time.</li>
                                                <li>Show a healthy return on investment (ROI) over time and having an active secondary market thanks to its brand equity.</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            What are En Primeur wines and how can I invest in them?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Also known as Wine Futures, En Primeur refers to the process of buying wines in the barrels before they are bottled. Wines are purchased Ex-Vat and Ex-Duty and usually, bottles are physically available 18-24 months after release. The benefits of buying En Primeur are:</p>
                                            <ul>
                                                <li>The opening En Primeur price is considerably cheaper than the future price of the wine on the open market.</li>
                                                <li>When purchasing En Primeur there will be several opportunities even before the wine is bottled to take advantage of price increases and make a profit.</li>
                                                <li>En Primeur can be the only way to secure wines that are available in very limited quantities.</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Which wines are best suited for investment?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Fine wine and notably investable fine wine is defined by three points:</p>
                                            <ul>
                                                <li>it comes from a specific, identifiable production area, producers or vineyard which possess a long-standing reputation for high quality. Production volumes are often limited.</li>
                                                <li>it has unique organoleptic properties like colour, flavour, bouquet and taste, universally recognised as such by the world’s most famous wine critics.</li>
                                                <li>it is created to improve as it ages.</li>
                                            </ul>
                                            <br/>
                                            Most of the world's investable wine is produced in Bordeaux, in western France. Burgundy, Champagne and Italy have been key drivers of growth in the last decade and the top wines of these regions are some of the most powerful fine wine brands today. The remainder comes from USA, Rhone Valley and a few notable exceptions from Spain, Germany, Austria, Australia and Latin America.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item>
                        <v-card flat>
                            <v-card-text>
                                <div class="tabs-title">{{ $t('support-faq-8') }}</div>
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Is the Vindome App free?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            The Vindome Mobile App is completely free to download and use.
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Can I personalise my App Dashboard?
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <p>Yes you can customise your dashboard by clicking “Change” in the top right hand corner of the screen. This feature allows you to add and remove custom widgets as well as reorder them to personalize your experience.</p>
                                            Each widget is a wine investment product category. The custom widgets are:<br/><br/>
                                            <ul>
                                                <li>Latest releases</li>
                                                <li>Top movers</li>
                                                <li>Most popular</li>
                                                <li>Favourites</li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </div>
        </section>

        <section id="contacts" ref="contacts" class="support-contact-wrapper">
            <div class="container1366 padding200 padding80">
                <h2>{{ $t('contact0') }}</h2>
                <div class="title-border"></div>
                <div class="contact-wrapper">
                    <div class="contact-wrapper-left">
                        <div class="contact-wrapper-left-title">Vindome EOOD</div>
                        <div class="contact-wrapper-left-subtitle">9 Simeonovsko shose Blvd, entr. E, fl. 7, apt. 115</div>
                        <div class="contact-wrapper-left-subtitle">1700, Sofia</div>
                        <div class="contact-wrapper-left-subtitle">Bulgaria</div>
                        <div class="contact-wrapper-left-href">
                            <a class="contact-wrapper-left-subtitle" href="tel:+37799906456">+377 99 90 64 56</a>
                        </div>
                        <div>
                            <a class="contact-wrapper-left-subtitle" href="mailto:info@vindome.net">info@vindome.net</a>
                        </div>
                        <div class="contact-wrapper-left-title" style="margin-top: 32px;">Customer support:</div>
                        <div class="contact-wrapper-left-subtitle">Monday - Friday</div>
                        <div class="contact-wrapper-left-subtitle">09.00 - 18.00 (CET)</div>
                    </div>
                    <div class="contact-wrapper-right">
                        <div class="contact-wrapper" v-if="!successMessage">
                            <v-select
                                :items="topicsList"
                                :placeholder="$t('contact8')"
                                item-text="value"
                                item-value="id"
                                class="topics-ddl"
                                v-model="selectedTopic"
                            ></v-select>
                            <div class="contact-row">
                                <div class="home-left-50">
                                    <v-text-field
                                        v-model="loginName"
                                        :label="$t('contact1')"
                                        outlined
                                        :rules="[rules.required]"
                                    ></v-text-field>
                                </div>
                                <div class="home-right-50">
                                    <v-text-field
                                        v-model="loginEmail"
                                        :label="$t('contact2')"
                                        outlined
                                        :rules="[rules.required, rules.emailValid]"
                                    ></v-text-field>
                                </div>
                            </div>

                            <v-textarea
                                :label="$t('contact3')"
                                outlined
                                :rules="[rules.required]"
                                v-model="notes"
                                rows="3"
                            ></v-textarea>
                            <div v-if="showError" class="contact-error">Please fill all fields</div>
                            <v-btn class="contact-btn1" text v-on:click="sendContact">{{ $t('contact4') }}</v-btn>
                        </div>
                        <div class="contact-wrapper success-wrapper" v-else>
                            <div class="success-title">{{ $t('contact5') }}</div>
                            <div class="success-info">{{ $t('contact6') }}</div>
                            <v-btn class="done-btn" text v-on:click="resetForm">{{ $t('contact7') }}</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Support",
        head: {
            title: 'Support | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'how-it-works trading-desk inner-page'
            }
        },
        computed: {
            faqList() {
                return [
                    this.$i18n.t('faq1'),
                    this.$i18n.t('faq3'),
                    this.$i18n.t('faq5'),
                    'How to create a bid for a listed wine without a "YOU BUY" price?',
                    this.$i18n.t('faqnew37'),
                    this.$i18n.t('faq10'),
                    'How do I sell my wine?',
                    'How do I cancel a sell offer?',
                    'How do I set a price of the wine on the market?',
                    'How do I apply my promo code?',
                    'What does Vindome’s investment horizons mean?',
                    'Where can I see my bids and offers?',
                    'Can I add bottles from my personal wine cellar to my Vindome portfolio?',
                    'Is there a hold period for my investments?',
                    'Can I store my collections in your warehouses?',
                    'Where can I see information about my orders?',
                    'What is the Portfolio Performance feature?',
                    this.$i18n.t('faq105'),
                    'Where can I find my storage and insurance invoices?',
                    this.$i18n.t('faq69'),
                    this.$i18n.t('faq71'),
                    this.$i18n.t('faq77'),
                    this.$i18n.t('faq79'),
                    this.$i18n.t('faqnew72'),
                    'How is the VAT applied?',
                    this.$i18n.t('faqnew75'),
                    'Can my wine be delivered to my home address?',
                    this.$i18n.t('faqnew78'),
                    'Where is my wine stored?',
                    'How much does storage cost?',
                    'Is my wine insured?',
                    'How much does insurance cost?',
                    'What does the insurance cover?',
                    'Is it possible to visit the warehouse?',
                    'What is Vindome?',
                    this.$i18n.t('faq3'),
                    'Does Vindome have an app for iPhone and Android?',
                    'Does Vindome offer discounts?',
                    'Is the Vindome wine market connected to other platforms?',
                    'Why should I invest in wine through Vindome?',
                    'How does Vindome source its wine?',
                    'How does Vindome select its wines?',
                    'How do I start investing with Vindome?',
                    this.$i18n.t('faq73'),
                    'Do I need expertise to start investing in wine?',
                    'Why is fine wine a good investment?',
                    'What is an investable wine?',
                    'What are En Primeur wines and how can I invest in them?',
                    'Which wines are best suited for investment?',
                    'Is the Vindome App free?',
                    'Can I personalise my App Dashboard?'
                ]
            },
            filteredFAQs () {
                let _ids = {},
                    total = 0;

                this.faqList.forEach((el, index) => {
                    _ids[index] = {
                        show: el.toLowerCase().includes(this.search)
                    };

                    if (el.toLowerCase().includes(this.search)) {
                        total += 1
                    }
                });

                _ids.total = total;

                return _ids
            }
        },
        data() {
            return {
                search: '',
                loginName: '',
                loginEmail: '',
                notes: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'

                },
                successMessage: false,
                showError: false,
                selectedTab: null,
                selectedTopic: 1,
                topicsList: [
                    { id: 1, value: this.$i18n.t('contact-sales') },
                    { id: 2, value: this.$i18n.t('contact-delivery') },
                    { id: 3, value: this.$i18n.t('contact-tech') },
                    { id: 4, value: this.$i18n.t('contact-press') },
                    { id: 5, value: this.$i18n.t('contact-other') },
                ]
            }
        },
        methods: {
            async sendContact () {
                if (this.loginName === '' || this.loginEmail === '' || this.notes === '') {
                    this.showError = true;
                    return
                }

                let contactCtrl = this;
                let options = {
                    method: 'POST',
                    url: (this.selectedTopic === 1 ? 'https://forms.raketa.cloud/submit/EVmzyt8ikZ' : (this.selectedTopic === 2 ? 'https://forms.raketa.cloud/submit/U9uf2ljyZp' : (this.selectedTopic === 3 ? 'https://forms.raketa.cloud/submit/RfAnzbHaIz' : (this.selectedTopic === 4 ? 'https://forms.raketa.cloud/submit/MllCg6fZD5' : 'https://forms.raketa.cloud/submit/XXj4SzpmtB')))),
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {
                        data: {
                            name: this.loginName,
                            email: this.loginEmail,
                            message: this.notes
                        }
                    }
                };
                let response = await axios(options);
                let responseOK = response && response.status === 200 && response.statusText === 'OK';

                if (responseOK) {
                    contactCtrl.successMessage = true
                }
            },
            resetForm () {
                this.loginName = '';
                this.loginEmail = '';
                this.notes = '';
                this.successMessage = false
            }
        },
        mounted() {
            this.$nuxt.$on('goToSection', (sectionName) => {
                if (window) {
                    const element = document.getElementById(sectionName);
                    element.scrollIntoView({behavior: 'smooth'});
                }
            });

            if ( this.$route.query.selectedTopic === 'myaccount') {
                this.selectedTab = 1
            } else if ( this.$route.query.selectedTopic === 'buysell') {
                this.selectedTab = 2
            } else if ( this.$route.query.selectedTopic === 'myportfolio') {
                this.selectedTab = 3
            } else if ( this.$route.query.selectedTopic === 'billing') {
                this.selectedTab = 4
            } else if ( this.$route.query.selectedTopic === 'delivery') {
                this.selectedTab = 5
            } else if ( this.$route.query.selectedTopic === 'storage') {
                this.selectedTab = 6
            } else if ( this.$route.query.selectedTopic === 'about') {
                this.selectedTab = 7
            } else if ( this.$route.query.selectedTopic === 'investments') {
                this.selectedTab = 8
            } else if ( this.$route.query.selectedTopic === 'app') {
                this.selectedTab = 9
            }
        }
  }
</script>

<style scoped>
    .contact-error {
        color: red;
        margin-bottom: 16px;
    }
    .search-results {
        position: relative;
    }
    .search-results-info {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #002840;
        position: absolute;
        top: -30px;
        left: 0;
    }
    .search-results-info span {
        font-weight: 700;
    }
    .search-results-table h3 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-top: 40px;
        text-transform: uppercase;
    }
    .academy-container {
        background: #ffffff;
    }
    h1 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 36px;
        line-height: 44px;
        text-align: center;
        color: #FFFFFF;
        margin-bottom: 16px;
    }
    h2 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #002840;
        text-align: center;
    }
    h3 {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: #002840;
        margin-bottom: 8px;
    }
    .home-left-50,
    .home-right-50 {
        display: inline-block;
        width: calc((100% - 24px) / 2);
        height: 100%;
        vertical-align: top;
    }
    .home-left-50 {
        margin-right: 20px;
    }
    .wine-guide-head {
        background: url('../assets/support.png') no-repeat center top;
        height: 300px;
        background-size: cover;
        margin-top: 80px;
        position: relative;
    }
    .wine-guide-head .inner-page-title {
        padding-top: 107px;
        z-index: 2;
        position: relative;
    }
    .wine-guide-head .how-subheading {
        text-align: center;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        color: #FFFFFF;
        z-index: 2;
        position: relative;
    }
    .container {
        position: relative;
        max-width: 1170px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 1;
    }
    .padding200 {
        padding: 0 200px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .title-border {
        width: 64px;
        height: 4px;
        background: #ECD9A7;
        margin: 24px auto 40px;
    }
    .tabs-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        color: #002840;
        margin-bottom: 8px;
    }
    .support-contact-wrapper {
        background: #f7f7f7;
    }
    .contact-wrapper-left {
        display: inline-block;
        vertical-align: top;
        width: 224px;
        height: 324px;
        border: 2px solid rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        padding: 16px;
        margin-right: 24px;
    }
    .contact-wrapper-left-title {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #002840;
        margin-bottom: 8px;
    }
    .contact-wrapper-left-subtitle {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #002840;
        text-decoration: none;
    }
    .contact-wrapper-left-href {
        margin-top: 16px;
    }
    .contact-wrapper-right {
        display: inline-block;
        vertical-align: top;
        width: calc(100% - 252px);
    }
    .contact-btn1 {
        font-family: 'Montserrat', sans-serif;
        padding: 8px 16px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        color: #ffffff;
        display: inline-block;
        vertical-align: top;
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 20px;
        text-transform: none;
        margin-top: 2px;
        letter-spacing: normal;
    }
    .success-wrapper {
        text-align: center;
        background: url('../assets/success_icon.png') no-repeat center 50px;
        border: 2px solid #ccc;
        padding: 160px 32px 40px;
        border-radius: 8px;
    }
    .done-btn {
        padding: 8px 16px;
        height: 36px;
        background: #004F7F;
        border-radius: 8px;
        color: #ffffff;
        margin-top: 36px;
    }

    @media(max-width: 767px) {
        .padding200 {
            padding: 0 16px;
        }
        .padding80 {
            padding-top: 32px;
            padding-bottom: 32px;
        }
        .contact-wrapper-left, .contact-wrapper-right {
            display: block;
            width: 100%;
        }
        .contact-btn1 {
            display: block;
            width: 300px;
            margin: 5px auto 0;
        }
        .wine-guide-head {
            height: 200px;
        }
        .wine-guide-head .inner-page-title {
            padding-top: 65px;
        }
        .vindome-breadcrumbs {
            display: none;
        }
    }
</style>

<style>
    .theme--light.topics-ddl.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
    }
    .theme--light.topics-ddl.v-text-field > .v-input__control > .v-input__slot {
        background-color: white;
        padding: 0 12px;
        border: 1px solid rgba(0, 0, 0, 0.42);
        border-radius: 4px;
        height: 54px;
    }
    .wine-academy-faq-tabs2.v-tabs--vertical {
        display: block;
    }
    .wine-academy-faq-tabs2.theme--light.v-tabs > .v-tabs-bar,
    .wine-academy-faq-tabs2 .theme--light.v-tabs-items,
    .wine-academy-faq-tabs2 .v-card {
        background: #ffffff !important;
    }
    .wine-academy-faq-tabs2 .theme--light.v-tabs-items {
        max-width: 100%;
        padding: 0;
        display: block;
        width: 100%;
        flex: 1 0 auto;
        margin-top: 48px;
    }
    .wine-academy-faq-tabs2 .v-expansion-panel::before,
    .search-results-table .v-expansion-panel::before{
        box-shadow: none;
    }
    .wine-academy-faq-tabs2 .v-expansion-panel-header,
    .search-results-table .v-expansion-panel-header {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #002840 !important;
        height: 40px;
        padding-left: 0;
        padding-right: 0;
    }
    .wine-academy-faq-tabs2 .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon,
    .search-results-table .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
        color: #004F7F;
        font-size: 27px;
    }
    .wine-academy-faq-tabs2.v-tabs--vertical > .v-tabs-bar .v-tab {
        padding: 6px 12px;
        height: 56px;
        background: #004F7F !important;
        border-radius: 8px;
        margin-bottom: 8px;
        color: #FFFFFF !important;
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        text-transform: none;
        letter-spacing: normal;
        display: inline-block;
        width: calc((100% - 72px) / 3);
    }
    .wine-academy-faq-tabs2.v-tabs--vertical > .v-tabs-bar .v-tab:before {
        content: none;
    }
    .wine-academy-faq-tabs2.v-tabs--vertical > .v-tabs-bar .v-tab.most-viewed {
        display: none !important;
    }
    .wine-academy-faq-tabs2.theme--light.v-tabs > .v-tabs-bar .v-tab:nth-child(3n+1),
    .wine-academy-faq-tabs2.theme--light.v-tabs > .v-tabs-bar .v-tab:nth-child(3n+2) {
        margin-left: 24px;
    }
    .wine-academy-faq-tabs2.theme--light.v-tabs .v-slide-group__content {
        display: block;
        white-space: pre-line;
    }
    .wine-academy-faq-tabs2.v-tabs--vertical > .v-tabs-bar .v-tab.v-tab--active {
        background: #5A8DAC !important;
        color: #ffffff !important;
    }
    .wine-academy-faq-tabs2 .v-tabs-slider-wrapper {
        display: none;
    }
    .wine-academy-faq-tabs2.theme--light.v-tabs > .v-tabs-bar {
        width: 100% !important;
        flex: 1 0 auto;
        max-width: 100%;
        display: block;
    }
    .wine-academy-faq-tabs2 .v-expansion-panel-content__wrap,
    .search-results-table .v-expansion-panel-content__wrap {
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #002840;
    }
    .wine-academy-faq-tabs2 .v-card__text {
        padding: 0 0 0 24px;
    }
    .wine-academy-faq-tabs2 .v-slide-group__wrapper {
        width: 100%;
        max-width: 100%;
        display: block;
        height: auto;
        white-space: pre-line;
    }
    .wine-academy-faq-tabs2 .theme--light.v-expansion-panels .v-expansion-panel,
    .search-results-table .theme--light.v-expansion-panels .v-expansion-panel {
        background: #ffffff !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.16) !important;
        border-radius: 0;
    }
    .contact-wrapper-right .v-text-field--outlined > .v-input__control > .v-input__slot {
        background: #ffffff;
    }
    .contact-wrapper-right .v-input input {
        max-height: 54px;
        border-bottom: 0;
    }
    .v-application .contact-wrapper-right .primary--text.v-label {
        color: #000000 !important;
    }
    .contact-wrapper-right .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 0;
    }
    .contact-wrapper-right .v-text-field.v-textarea {
        padding-top: 0;
    }
    .v-application--is-ltr .contact-wrapper-right .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
        margin-right: 2px;
    }
    .contact-wrapper-right .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 54px;
    }
    .how-it-works .header-toolbar {
        box-shadow: none;
    }
    .inner-page-app .hide-mobile {
        display: none;
    }
    .search-txt.v-text-field {
        padding-top: 0;
        margin-top: 0;
        border: 1px solid #D9D7DB;
        border-radius: 4px;
        margin-bottom: 40px;
    }
    .search-txt.v-text-field  .v-input__slot {
        margin-bottom: 0;
    }
    .search-txt.v-text-field  .v-text-field__details,
    .search-txt.v-text-field.v-input > .v-input__control > .v-input__slot:before,
    .search-txt.v-text-field.v-input > .v-input__control > .v-input__slot:after {
        display: none;
    }
    .search-txt.v-text-field.v-input input {
        max-height: 54px;
        border: 0;
        padding: 16px;
        color: rgba(4, 1, 13, 0.6);
        font-family: 'Montserrat', sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        border-radius: 4px;
        background: url('../assets/faq_search.png') no-repeat right center;
        background-position-x: calc(100% - 20px);
    }

    @media(max-width: 767px) {
        .wine-academy-faq-tabs2.theme--light.v-tabs > .v-tabs-bar {
            width: 100%;
        }
        .v-tabs.wine-academy-faq-tabs2.v-tabs--vertical {
            display: block;
        }
        .wine-academy-faq-tabs2 .theme--light.v-tabs-items {
            margin-top: 32px;
        }
    }
</style>
